import { observer } from 'mobx-react-lite';

import type { INotificationsService } from '../../shared/INotificationsService';
import { AlertRulesTable } from '../alert-rules-table/AlertRulesTable';
import type { AlertRulesService } from '../alert-rules-table/services/AlertRulesService';
import type { AlertsManagerWidgetState } from '../AlertsManagerWidgetState';
import type { ViewStore } from '../stores/ViewStore';

type AlertRulesViewProps = {
  viewStore: ViewStore;
  service: AlertRulesService;
  notifications: INotificationsService;
  widgetState: AlertsManagerWidgetState;
};

export const AlertRulesView = observer(function AlertRulesView({
  viewStore,
  service,
  notifications,
  widgetState,
}: AlertRulesViewProps) {
  return (
    <AlertRulesTable viewStore={viewStore} service={service} notifications={notifications} widgetState={widgetState} />
  );
});
